import { CommonModule, NgForOf, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { StringUtilsHelper } from "../../helpers/strings.helper";

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
    standalone: true,
    imports: [
        NgIf
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageComponent implements OnInit{
    @Input() image: string = "";
    @Input() fullName: string = "";
    @Input() classImage? = "rounded-circle img-fluid";
		@Input() classContainer? = "user-avatar rounded-circle border border-5 border-alternative";

    imageComplete: string = "";
    typeImage: string;
    listMime: Map<string, string> = new Map();


    constructor(){
        this.listMime.set("svg+xml","PHN2Zy");
        this.listMime.set("jpeg","/9j/");
        this.listMime.set("png","iVBORw0KGgo");
        this.listMime.set("bmp","Qk");
        this.listMime.set("octet-stream","UklGR");//webp
        this.listMime.set("x-icon","AAABAA");
        this.listMime.set("gif","R0lGOD");

    }
    ngOnInit(): void {
      this.detectMimeType(this.image);
    }
    private detectMimeType(imgB64: string) {
    if(imgB64 == null){
        console.log('No hay Imagen');
        return;
    }
        if(imgB64.startsWith("data:image/")){
            this.imageComplete = imgB64;
        } else {
            this.listMime.forEach( (value, key) => {
                if (imgB64.startsWith(value)) {
                    this.typeImage = key;
                }
            });
            this.imageComplete = "data:image/" + this.typeImage + ";base64," + this.image;
        }
    }

    getLogoLetters(fullName: string): string{
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(fullName)) {
            let nameInParts = fullName.split(' ');
            let firstInitial = nameInParts[0].charAt(0);
            let pos: number = 0;
            if(nameInParts.length === 2){
                pos = nameInParts.length - 1;
            } else {
                pos = nameInParts.length - 2;
            }
            let lastNames = nameInParts[pos].split('-');
            let lastNameInitial = lastNames[0].charAt(0);
    
            return firstInitial + lastNameInitial;
        } else {
            return "AB";
        }
    }

}
